import {
  AuthAccountOrganizationStatusChoices,
  CheckBadgeIcon,
  CircleClockIcon,
  Close2Icon,
  DangerIcon,
} from "@cpj-ai/panel-npm-package";

interface StatusConfig {
  label: string;
  color: string;
  fillColor: string;
  strokeColor: string;
  icon: React.ElementType;
  iconClassName?: string;
}

export const statusConfig: Record<AuthAccountOrganizationStatusChoices, StatusConfig> = {
  VERIFIED: {
    label: "Verified",
    icon: CheckBadgeIcon,
    color: "text-green-500",
    fillColor: "#00c951",
    strokeColor: "#fff",
  },
  DRAFTED: {
    label: "Draft",
    icon: DangerIcon,
    color: "text-yellow-500",
    fillColor: "#efb100",
    strokeColor: "none",
  },
  SUBMITTED: {
    label: "Awaiting approval",
    icon: CircleClockIcon,
    color: "text-blue-500 ",
    fillColor: "#2b7fff",
    strokeColor: "none",
  },
  REJECTED: {
    label: "Rejected",
    icon: Close2Icon,
    color: "text-red-500 ",
    fillColor: "none",
    strokeColor: "#fb2c36",
    iconClassName: "!w-4 !h-4",
  },
  BLOCKED: {
    label: "Suspended",
    icon: CircleClockIcon,
    color: "text-red-500 ",
    fillColor: "#fb2c36",
    strokeColor: "none",
  },
  COMPLETED: {
    label: "Information Completed",
    icon: CircleClockIcon,
    color: "text-green-500 ",
    fillColor: "#00c951",
    strokeColor: "none",
  },
} as const;

export type Status = keyof typeof statusConfig;
